<template>
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M16.4531 8.95703L4.20312 3.70703C4.09375 3.65234 3.98438 3.625 3.875 3.625C3.62891 3.625 3.38281 3.70703 3.21875 3.89844C2.97266 4.17188 2.91797 4.58203 3.08203 4.91016L5.625 9.75L3.08203 14.6172C2.91797 14.9453 2.97266 15.3555 3.21875 15.6016C3.38281 15.793 3.62891 15.9023 3.875 15.9023C3.98438 15.9023 4.09375 15.875 4.20312 15.8203L16.4531 10.5703C16.7812 10.4336 17 10.1055 17 9.75C16.9727 9.42188 16.7812 9.09375 16.4531 8.95703ZM4.80469 5.40234L13.4727 9.09375H6.74609L4.80469 5.40234ZM6.74609 10.4062H13.4727L4.80469 14.125L6.74609 10.4062Z"
      fill="currentColor"
    />
  </svg>
</template>
